export default __webpack_public_path__ + "70fc443eacdbf156041d0430219a8386.svg";